import { getPriceDirection, getPriceDirectionLabel } from '~/components/LERE/formatters/toursPricingUtils';
import type { LereToursPricingSuggestion } from '~/components/LERE/types';

const percent = (value: number) =>
  `${value < 0 ? '−' : '+'}${Math.abs(value * 100).toLocaleString('en-AU', { maximumFractionDigits: 2 })}%`;
export function pricingRecommendationLabel(row: LereToursPricingSuggestion): string {
  const direction = getPriceDirection(row);
  const target = row.suggested_price_change_percent;
  const current = row.current_price_delta_percent;
  if (target === 0) {
    if (direction !== 'none' && current) {
      return `Remove ${percent(current)} ${current > 0 ? 'surcharge' : 'discount'} (back to base)`;
    }
    return direction === 'none' ? 'Keep base price' : 'Return to base price';
  }
  return `${percent(target)} ${target > 0 ? 'surcharge' : 'discount'}${current == null ? '' : ` (now ${current === 0 ? 'base' : percent(current)})`}`;
}
export function pricingRecommendationTooltip(row: LereToursPricingSuggestion): string {
  return [
    pricingRecommendationLabel(row),
    getPriceDirectionLabel(getPriceDirection(row)),
    row.reason_headline,
    ...(row.reason_points ?? []),
  ]
    .filter(Boolean)
    .join('\n');
}
